import axios from "axios";
import * as Endpoints from "../entities/Endpoints";
import config from "../config/config";

const axiosInstance = axios.create({
  baseURL: Endpoints.API_ENDPOINT,
});

// 🔹 Refresh Token with B2C ROPC
const refreshTokenLogin = async () => {
  const refreshToken = localStorage.getItem("RefreshToken");
  if (!refreshToken) return null;

  try {
    const tenant = config.CUSTOME_TENANT_NAME;
    const policy = config.CUSTOME_POLICY_NAME;
    const clientId = config.MSAL_CLIENT_ID;
    const scope = config.SCOPE_USER_READWRITE_ALL;

    const b2cloginURL = `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${policy}/oauth2/v2.0/token`;

    const body = new URLSearchParams({
      grant_type: "refresh_token",
      refresh_token: refreshToken,
      client_id: clientId,
      scope: `${scope} openid offline_access`,
    }).toString();

    const response = await fetch(b2cloginURL, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error_description || "Refresh token failed");
    }

    if (!data.access_token) {
      throw new Error("No access token received during refresh");
    }

    // 🔥 Save new tokens
    localStorage.setItem("Token", data.access_token);
    localStorage.setItem("RefreshToken", data.refresh_token || "");
    localStorage.setItem("TokenTimestamp", new Date().getTime());

    return data.access_token;
  } catch (err) {
    console.error("Refresh token error:", err.message);
    return null;
  }
};

// 🔹 Request Interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    let token = localStorage.getItem("Token");

    // Token expiry check (10 mins)
    const tokenExpiryTime = 10 * 60 * 1000;
    const tokenTimestamp = localStorage.getItem("TokenTimestamp");
    const currentTime = new Date().getTime();

    if (
      !token ||
      (tokenTimestamp && currentTime - tokenTimestamp > tokenExpiryTime)
    ) {
      // Expired → try refresh
      token = await refreshTokenLogin();
      if (!token) {
        // If refresh fails → logout
        localStorage.removeItem("Token");
        localStorage.removeItem("RefreshToken");
        localStorage.removeItem("userName");
        localStorage.removeItem("TokenTimestamp");
        localStorage.setItem("isAuthenticated", "false");
        localStorage.removeItem("coachemail");
        window.location.href = "/";
        return Promise.reject("Session expired. Please log in again.");
      }
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // Try refresh token
      const token = await refreshTokenLogin();
      if (token) {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return axiosInstance(originalRequest);
      }

      // If refresh also fails → logout
      localStorage.clear();
      window.location.href = "/login";
    }

    console.error("API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  }
);

export default axiosInstance;
